import React from 'react';

// Removed WhatsApp QR code URL

const ContactSection: React.FC = () => {
  return (
    <section id="contact" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="inline-block px-3 py-1 bg-accent/10 text-accent rounded-full font-medium text-sm mb-4">
            Get In Touch
          </div>
          <h2 className="text-3xl md:text-4xl font-heading font-bold mb-4 text-text">
            Contact Us
          </h2>
          <p className="max-w-2xl mx-auto text-gray-600">
            Interested in our products or have questions? Reach out to us directly through any of these channels.
          </p>
        </div>
        
        <div className="max-w-2xl mx-auto">
          {/* Contact Info */}
          <div className="w-full">
            <div className="bg-white shadow-lg rounded-lg overflow-hidden">
              <div className="bg-primary text-white p-6">
                <h3 className="text-xl font-heading font-bold mb-2">Contact Information</h3>
                <p className="text-white/80">Here are the best ways to reach us</p>
              </div>
              
              <div className="p-6">
                <div className="space-y-6">
                  {/* Phone */}
                  <div className="flex items-start">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary/10 text-primary mr-4 flex-shrink-0">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                      </svg>
                    </div>
                    <div>
                      <h4 className="font-heading font-bold text-text mb-1">Call Us</h4>
                      <p className="text-gray-600 mb-1">We're available Monday-Friday, 5am-3pm</p>
                      <a href="tel:+27635071011" className="text-primary font-medium hover:underline">+27 63 507 1011</a>
                    </div>
                  </div>
                  
                  {/* Email */}
                  <div className="flex items-start">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent/10 text-accent mr-4 flex-shrink-0">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                      </svg>
                    </div>
                    <div>
                      <h4 className="font-heading font-bold text-text mb-1">Email Us</h4>
                      <p className="text-gray-600 mb-1">We'll respond within 24 hours</p>
                      <a href="mailto:jason@madanglers.co.za" className="text-primary font-medium hover:underline">jason@madanglers.co.za</a>
                    </div>
                  </div>
                  
                  {/* Business Hours */}
                  <div className="flex items-start">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary/10 text-primary mr-4 flex-shrink-0">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <div>
                      <h4 className="font-heading font-bold text-text mb-1">Business Hours</h4>
                      <p className="text-gray-600 mb-1">Monday - Friday: 7:00 AM - 3:00 PM</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection; 